// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import { PRESUPUESTADOR_ADD_USADO_ENTREGAR, PRESUPUESTADOR_ADD_USADO_ENTREGAR_REJECT } from './constants'
import validatePatente from '../../common/backend/validatePatente'

export function addUsadoEntregar({ params }) {
  return (dispatch, getState) => {
    if(params.patente) {
      if (!validatePatente(params.patente)) {
        const error = 'INGRESE UNA PATENTE VALIDA'
        dispatch({
          type: PRESUPUESTADOR_ADD_USADO_ENTREGAR_REJECT,
          data: {
            error,
          },
        })
        return false
      }
    }

    const state = getState()
    let existePatente = false
    if(params.patente){
      existePatente = state.presupuestador.entregaUsados.some((item) => item.patente === params.patente)
    }

    if (existePatente) {
      const error = 'YA SE AGREGO ESTA PATENTE'
      dispatch({
        type: PRESUPUESTADOR_ADD_USADO_ENTREGAR_REJECT,
        data: {
          error,
        },
      })
      return false
    }

    dispatch({ type: PRESUPUESTADOR_ADD_USADO_ENTREGAR, data: params })
    return true
  }
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_ADD_USADO_ENTREGAR:
      return {
        ...state,
        patenteReject: null,
        entregaUsados: [
          {
            oldValue: 0,
            final_take_price: action.data.appraisal,
            quotation_id: action.data.requestsId,
            year: action.data.verification.vehicle.year.label,
            brand: action.data.verification.vehicle.brand.label,
            model: action.data.verification.vehicle.model.label,
            version: action.data.verification.vehicle.version.label,
            versionId: action.data.verification.vehicle.version.value,
            km: action.data.verification.kilometraje,
            appraisal: action.data.appraisal,
            peritado: action.data.verification.statusId,
            verificationDate: action.data.verification.verificationDate,
            patente: action.data.patente,
            pending: false,
            error: null,
            valid: true,
            original_price: action.data.appraisal,
            use_take_improvement: 0,
            take_improvement_amount: 0,
            version_id:action.data.verification.vehicle.version.value,
            license_plate: action.data.patente,
            requestsId: action.data.requestsId
          },
        ].concat(state.entregaUsados),
      }
    case PRESUPUESTADOR_ADD_USADO_ENTREGAR_REJECT:
      return {
        ...state,
        patenteReject: action.data.error,
      }

    default:
      return state
  }
}
